import { combineReducers } from 'redux'

import { ISoftionState } from '../types'
import communications from './communications'
import data from './data'

export const reducer = combineReducers<ISoftionState>({
  communications,
  data,
})
